import React from 'react'
import Chip from '../atoms/chip/Chip'

const Defaults = ({ items = [], className = '' }) => {
  return (
    <ul className={className}>
      {items.map((item) => (
        <li
          className="inline-block"
          key={item.title}
        >
          <Chip
            href={item.link}
            linkTitle={item.title}
            className="mb-2 mr-2"
          >
            {item.title}
          </Chip>
        </li>
      ))}
    </ul>
  )
}
export default Defaults
